export const buildVariables: any = {"buildNumber":"20231207.2","buildDate":"2023-12-07 06:29:32-05:00","buildCommitMessage":"#13300 Fix shipping label conditions","svgSpritePath":"/assets/sprite/icons-5a984c11.svg"};
